import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Slider from "react-slick";
import ImageSlide from "./ImageSlide";
import VideoSlide from "./VideoSlide";
import PdfSlide from "./PdfSlide";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.scss";

interface slide {
  src: string;
  type: string;
  duration?: number;
}
interface Props {
  slides: slide[];
}

const Carousel: React.FC<Props> = ({ slides }) => {
  const [curr, updateIndex] = useState(0);
  const [nav, setNav] = useState<Slider | null>();
  const [start, setStart] = useState(true);
  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (curr: number) => updateIndex(curr),
  };
  const nextSlide = () => {
    if (nav) {
      nav.slickNext();
    }
  };
  const pathname = useLocation().pathname;

  React.useEffect(() => {
    if (slides?.length) {
      let slide = slides[curr] ? slides[curr] : slides[0];

      if (slide.duration && !slide.type.includes("video")) {
        const timer2 = setTimeout(() => {
          nextSlide();
          setStart(false);
        }, slide.duration * 1000);
        return () => {
          clearTimeout(timer2);
        };
      }
    }
  }, [nextSlide, start, slides]);

  return (
    <div className={"banner"}>
      <Slider ref={(c: any) => setNav(c)} {...settings}>
        {slides?.map((slide, index) => {
          return (
            <div key={index}>
              {slide.type === "video/mp4" && (
                <VideoSlide
                  key={index}
                  index={index}
                  curr={curr}
                  src={slide.src}
                  loop={slides.length === 1}
                  nextSlide={nextSlide}
                />
              )}
              {slide.type.includes("image") && (
                <ImageSlide
                  key={index}
                  index={index}
                  curr={curr}
                  src={slide.src}
                  durr={slide.duration ? slide.duration : 10}
                  nextSlide={nextSlide}
                />
              )}
              {slide.type.includes("pdf") && (
                <PdfSlide
                  key={index}
                  index={index}
                  curr={curr}
                  src={slide.src}
                  durr={slide.duration ? slide.duration : 10}
                  nextSlide={nextSlide}
                />
              )}
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Carousel;
